import type {App, Plugin} from "vue";

import {odsBox} from "./odsBox";
import {odsButton} from "./odsButton";
import {odsCard} from "./odsCard";
import {odsCheckbox} from "./odsCheckbox";
import {odsFieldMessage} from "./odsFieldMessage";
import {odsIcon} from "./odsIcon";
import {odsInput} from "./odsInput";
import {odsLogo} from "./odsLogo";
import {odsNavigation} from "./odsNavigation";
import {odsPill} from "./odsPill";
import {odsPopup} from "./odsPopup";
import {odsSelect} from "./odsSelect";
import {odsTextarea} from "./odsTextarea";
import {odsRadar} from "./odsRadar";
import {odsSwitch} from "./odsSwitch";
import {odsDropdown} from "./odsDropdown";

import "../assets/styles/all.scss"

export * from "./odsBox";
export * from "./odsButton";
export * from "./odsCard";
export * from "./odsCheckbox";
export * from "./odsFieldMessage";
export * from "./odsIcon";
export * from "./odsInput";
export * from "./odsLogo";
export * from "./odsNavigation";
export * from "./odsPill";
export * from "./odsPopup";
export * from "./odsSelect";
export * from "./odsTextarea";
export * from "./odsRadar";
export * from "./odsSwitch";
export * from "./odsDropdown";

export * from "../tokens"

export default {
  install: (app: App) => {
    app.component('odsBox', odsBox);
    app.component('odsButton', odsButton);
    app.component('odsCard', odsCard);
    app.component('odsCheckbox', odsCheckbox);
    app.component('odsFieldMessage', odsFieldMessage);
    app.component('odsIcon', odsIcon);
    app.component('odsInput', odsInput);
    app.component('odsLogo', odsLogo);
    app.component('odsNavigation', odsNavigation);
    app.component('odsPill', odsPill);
    app.component('odsPopup', odsPopup);
    app.component('odsSelect', odsSelect);
    app.component('odsTextarea', odsTextarea);
    app.component('odsRadar', odsRadar);
    app.component('odsSwitch', odsSwitch);
    app.component('odsDropdown', odsDropdown);
  }
} satisfies Plugin;
